import { render, staticRenderFns } from "./ParentSubjectUploadCard.vue?vue&type=template&id=6fbcf658&"
import script from "./ParentSubjectUploadCard.vue?vue&type=script&lang=js&"
export * from "./ParentSubjectUploadCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports